import PaymentMethodPanel from './PaymentMethodPanel';

export default PaymentMethodPanel;
